import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const deleteCannedMessages = async (_id: string): Promise<AxiosResponse> =>
  AxiosInstance.delete('canned-responses', { data: { _id } });
